import { theme } from '@fiverr-private/theme';
import useElementSize from '../useElementSize';

const breakpoints = theme.numericBreakpoints;

type Breakpoints = keyof typeof breakpoints;

/**
 * Returns the current breakpoint on CSR according to `@fiverr-private/theme` breakpoints definition.
 */
const useBreakpoint = (): Breakpoints | 'default' | undefined => {
    const { width: windowWidth } = useElementSize(typeof window !== 'undefined' ? window : null);

    if (windowWidth > breakpoints.xxl) return 'xxl';

    if (windowWidth > breakpoints.xl) return 'xl';

    if (windowWidth > breakpoints.lg) return 'lg';

    if (windowWidth > breakpoints.md) return 'md';

    if (windowWidth > breakpoints.sm) return 'sm';

    return windowWidth > 0 ? 'default' : undefined;
};

export default useBreakpoint;
